export const mutations = {
  STORE_BONDS(state, bonds) {
    state.bonds = bonds;
  },
  STORE_BOND_UPDATE(state, bondId) {
    let Bond = state.bonds.find(function(bond) {
      return bond.id === bondId;
    });
    state.systemBond = Bond;
  },

  STORE_CUSTOMBONDS(state, custombonds) {
    state.custombonds = custombonds;
  },

  STORE_CUSTOMBOND_UPDATE(state, cargoId) {
    let Custombond = state.custombonds.find(function(custombond) {
      return custombond.id === cargoId;
    });
    state.systemCustombond = Custombond;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/bonds/mutations.js